/** @format */
import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ModuleAttainmentApplication } from 'common-typescript/types';
import { ComponentDowngradeMappings, DEFAULT_PROMISE_HANDLER, DowngradedComponent, StaticMembers } from 'sis-common';
import { HeaderService } from 'sis-components';
import { ApplicationModalService } from '../application-modal.service';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'app-module-attainment-application',
    templateUrl: './module-attainment-application.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ModuleAttainmentApplicationComponent implements OnInit {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'student.profile.applications.moduleAttainmentApplicationNg',
        directiveName: 'appModuleAttainmentApplication',
    };

    @Input() application: ModuleAttainmentApplication;

    constructor(
        private applicationModalService: ApplicationModalService,
        private headerService: HeaderService,
        @Inject(DEFAULT_PROMISE_HANDLER) private defaultPromiseHandler: any,
    ) {}

    ngOnInit(): void {
        this.headerService.setApplicationStateBadge(this.application);
    }

    cancelApplication() {
        this.applicationModalService.openCancelApplicationModal(this.application).subscribe({
            error: this.defaultPromiseHandler.loggingRejectedPromiseHandler,
            complete: () => {
                this.headerService.setApplicationStateBadge(this.application);
            },
        });
    }
}
